import { Flex, useMultiStyleConfig } from '@chakra-ui/react';

import { Helmet } from 'react-helmet-async';

import { AuthenticatedPageWrapperProps } from './types';

function AuthenticatedPageWrapper({
  children,
  title,
  hasBanner = false,
  // Backoffice is data-dense (wide tables), so pages span the full width by default.
  // A page can pass fullWidth={false} to opt into the 1440px centred cap.
  fullWidth = true,
}: AuthenticatedPageWrapperProps) {
  const styles = useMultiStyleConfig('AuthenticatedPageWrapper', { hasBanner, fullWidth });

  return (
    <>
      <Helmet>
        <title>{title} | Aslan</title>
      </Helmet>

      <Flex sx={{ ...styles.container }} gap="20px">
        {children}
      </Flex>
    </>
  );
}

export default AuthenticatedPageWrapper;
